import React, { useState } from "react";
import { Link } from "react-router-dom";
import Footer from "../components/Footer";
import EpitkezesiLeadForm from "../components/EpitkezesiLeadForm";

const structures = [
  {
    id: "fa",
    name: "Fa szerkezet",
    price: "390.000",
    icon: "🌲",
    color: "from-amber-600 to-amber-800",
    borderColor: "border-amber-500/30 hover:border-amber-500",
    features: ["Gyors kivitelezés", "Energiahatékony", "Modern megjelenés", "Könnyű szerkezet"],
    description: "Gyors · energiahatékony · modern",
    details: "A fa szerkezet a leggyorsabb és leginkább költséghatékony megoldás. Modern, skandináv jellegű házak készülnek belőle, kiváló hőszigetelési tulajdonságokkal."
  },
  {
    id: "blokk",
    name: "Blokk (viablokk)",
    price: "440.000",
    icon: "🧱",
    color: "from-gray-600 to-gray-800",
    borderColor: "border-gray-500/30 hover:border-gray-500",
    features: ["Masszív szerkezet", "Jó ár-érték", "Időtálló", "Hangszigetelés"],
    description: "Masszív · időtálló · jó ár-érték",
    details: "A viablokk szerkezet kiváló ár-érték arányt kínál. Masszív, időtálló házak készülnek belőle, jó hangszigetelési tulajdonságokkal."
  },
  {
    id: "tegla",
    name: "Tégla",
    price: "490.000",
    icon: "🏛️",
    color: "from-red-700 to-red-900",
    borderColor: "border-red-500/30 hover:border-red-500",
    features: ["Klasszikus minőség", "Értékálló", "Hosszú élettartam", "Prémium kivitel"],
    description: "Klasszikus · értékálló · hosszú távra",
    details: "A tégla a legklasszikusabb építőanyag. Értékálló, prémium minőségű házak készülnek belőle, amelyek generációkon át megőrzik értéküket."
  }
];

const processSteps = [
  { num: 1, title: "Kapcsolatfelvétel", desc: "Egyeztess velünk az igényeidről" },
  { num: 2, title: "Előminősítés", desc: "Felmérjük a lehetőségeket" },
  { num: 3, title: "Szerkezeti döntés", desc: "Fa, blokk vagy tégla" },
  { num: 4, title: "Partneri tárgyalás", desc: "Összekötünk a kivitelezővel" },
  { num: 5, title: "Ajánlat", desc: "Részletes árajánlat" },
  { num: 6, title: "Szerződés", desc: "Minden tisztán, írásban" },
  { num: 7, title: "Kivitelezés", desc: "Kontrollált építési folyamat" }
];

const includedFeatures = [
  { icon: "❄️", title: "Klímás hűtés–fűtés", desc: "Korszerű fűtési és hűtési rendszer" },
  { icon: "🏠", title: "Korszerű szigetelés", desc: "Energiahatékony hőszigetelés" },
  { icon: "🔑", title: "Kulcsrakész kivitelezés", desc: "Beköltözhető állapot" },
  { icon: "✨", title: "Minőségi anyagok", desc: "Prémium építőanyagok" },
  { icon: "🤝", title: "Partneri kivitelezés", desc: "Ellenőrzött kivitelezők" },
  { icon: "📋", title: "Garancia", desc: "Teljes körű garancia" }
];

export default function EgyediHazak() {
  const [selectedStructure, setSelectedStructure] = useState(null);
  const [openFaq, setOpenFaq] = useState(null);

  return (
    <div className="bg-black text-white min-h-screen">
      
      {/* Hero Section */}
      <section className="relative py-16 md:py-24 bg-gradient-to-b from-black via-[#0a0a0a] to-[#111]">
        <div className="max-w-5xl mx-auto px-4 text-center">
          <h1 className="text-3xl md:text-5xl lg:text-6xl font-black mb-4 md:mb-6">
            Nem háztervet választasz.
          </h1>
          <p className="text-xl md:text-3xl text-secondary font-semibold mb-6">
            Egy biztos építési rendszert.
          </p>
          <p className="text-gray-400 text-sm md:text-lg max-w-2xl mx-auto leading-relaxed">
            Először az árat, a szerkezetet és a folyamatot érted meg.
            A ház ezután születik meg – a te igényeid szerint.
          </p>
        </div>
      </section>

      {/* Structure Cards */}
      <section className="py-12 md:py-20 bg-[#0a0a0a]">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
            Válaszd ki a szerkezetet
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {structures.map((structure) => (
              <div
                key={structure.id}
                onClick={() => setSelectedStructure(selectedStructure === structure.id ? null : structure.id)}
                className={`relative bg-[#1a1a1a] rounded-2xl p-6 border-2 transition-all duration-300 cursor-pointer
                  ${structure.borderColor}
                  ${selectedStructure === structure.id ? 'ring-2 ring-secondary scale-[1.02]' : ''}
                `}
              >
                {/* Icon & Title */}
                <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${structure.color} flex items-center justify-center text-3xl mb-4`}>
                  {structure.icon}
                </div>
                
                <h3 className="text-xl font-bold text-white mb-2">
                  {structure.name}
                </h3>
                
                <p className="text-gray-500 text-sm mb-4">
                  {structure.description}
                </p>
                
                {/* Price */}
                <div className="mb-4">
                  <span className="text-3xl font-black text-white">{structure.price}</span>
                  <span className="text-gray-400 text-sm ml-1">Ft / m² (nettó)</span>
                </div>
                
                {/* Features */}
                <ul className="space-y-2 mb-4">
                  {structure.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-2 text-sm text-gray-300">
                      <span className="text-green-400">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
                
                {/* Expanded Details */}
                {selectedStructure === structure.id && (
                  <div className="mt-4 pt-4 border-t border-white/10">
                    <p className="text-gray-400 text-sm leading-relaxed">
                      {structure.details}
                    </p>
                  </div>
                )}
                
                {/* Click indicator */}
                <div className="absolute top-4 right-4 text-gray-500 text-sm">
                  {selectedStructure === structure.id ? '▲' : '▼'}
                </div>
              </div>
            ))}
          </div>
          
          {/* CTA */}
          <div className="text-center mt-10">
            <Link
              to="/kapcsolat"
              className="inline-flex items-center gap-2 bg-secondary hover:bg-hover text-white font-bold px-8 py-4 rounded-xl text-lg transition-all"
            >
              👉 Kérek személyre szabott ajánlatot
            </Link>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-12 md:py-20 bg-[#111]">
        <div className="max-w-6xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-4">
            Mit tartalmaz az alapár?
          </h2>
          <p className="text-gray-400 text-center mb-10 max-w-2xl mx-auto">
            Az alapár egy komplett, kulcsrakész házat jelent – nem kell rejtett költségekkel számolnod.
          </p>
          
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 md:gap-6">
            {includedFeatures.map((feature, idx) => (
              <div key={idx} className="bg-[#1a1a1a] rounded-xl p-4 md:p-6 border border-white/5">
                <span className="text-2xl md:text-3xl mb-3 block">{feature.icon}</span>
                <h3 className="text-white font-semibold mb-1 text-sm md:text-base">{feature.title}</h3>
                <p className="text-gray-500 text-xs md:text-sm">{feature.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process */}
      <section className="py-12 md:py-20 bg-[#0a0a0a]">
        <div className="max-w-5xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-4">
            Hogyan zajlik a folyamat?
          </h2>
          <p className="text-gray-400 text-center mb-10">
            7 lépés a kulcsrakész otthonig
          </p>
          
          <div className="relative">
            {/* Timeline line */}
            <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-0.5 bg-gradient-to-b from-secondary via-secondary/50 to-transparent hidden md:block" />
            
            <div className="space-y-6">
              {processSteps.map((step, idx) => (
                <div 
                  key={step.num}
                  className={`flex items-start gap-4 ${idx % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`}
                >
                  {/* Content */}
                  <div className={`flex-1 ${idx % 2 === 0 ? 'md:text-right md:pr-8' : 'md:text-left md:pl-8'}`}>
                    <div className="bg-[#1a1a1a] rounded-xl p-4 inline-block border border-white/5">
                      <span className="text-secondary font-bold text-sm">Lépés {step.num}</span>
                      <h3 className="text-white font-semibold mt-1">{step.title}</h3>
                      <p className="text-gray-500 text-sm mt-1">{step.desc}</p>
                    </div>
                  </div>
                  
                  {/* Number circle - visible on mobile */}
                  <div className="w-8 h-8 rounded-full bg-secondary flex items-center justify-center text-white font-bold text-sm flex-shrink-0 md:absolute md:left-1/2 md:-translate-x-1/2">
                    {step.num}
                  </div>
                  
                  {/* Empty space for alternating layout */}
                  <div className="flex-1 hidden md:block" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* What We Do / Don't Do */}
      <section className="py-12 md:py-20 bg-[#111]">
        <div className="max-w-4xl mx-auto px-4">
          <h2 className="text-2xl md:text-3xl font-bold text-center mb-10">
            Miben vagyunk mások?
          </h2>
          
          <div className="grid md:grid-cols-2 gap-6">
            {/* What we do */}
            <div className="bg-green-500/5 border border-green-500/20 rounded-2xl p-6">
              <h3 className="text-green-400 font-bold text-lg mb-4 flex items-center gap-2">
                <span>✓</span> Amit biztosítunk
              </h3>
              <ul className="space-y-3 text-gray-300 text-sm">
                <li>• Átlátható árképzés m²-re</li>
                <li>• Előminősített kivitelező partnerek</li>
                <li>• Kontrollált építési folyamat</li>
                <li>• Egységes minőségi elvárások</li>
                <li>• Folyamatos kommunikáció</li>
              </ul>
            </div>
            
            {/* What we don't do */}
            <div className="bg-red-500/5 border border-red-500/20 rounded-2xl p-6">
              <h3 className="text-red-400 font-bold text-lg mb-4 flex items-center gap-2">
                <span>✗</span> Amit nem csinálunk
              </h3>
              <ul className="space-y-3 text-gray-300 text-sm">
                <li>• Nem tervezünk</li>
                <li>• Nem kivitelezünk közvetlenül</li>
                <li>• Nem vállalunk műszaki felelősséget</li>
                <li>• Nem kötünk ki egyetlen partnert</li>
              </ul>
            </div>
          </div>
          
          <div className="text-center mt-8">
            <p className="text-gray-400 text-sm italic">
              „Mi nem kivitelezünk. Mi biztosítjuk, hogy jó kivitelezővel, jó áron, jó folyamatban építkezz."
            </p>
          </div>
        </div>
      </section>

      {/* Lead Form Section - Zárt Partnermodell */}
      <section id="ajanlatkeres" className="py-16 md:py-24 bg-gradient-to-b from-[#0a0a0a] to-black">
        <div className="max-w-2xl mx-auto px-4">
          <div className="text-center mb-8">
            <h2 className="text-2xl md:text-4xl font-bold mb-4">
              Készen állsz az építkezésre?
            </h2>
            <p className="text-gray-400">
              Töltsd ki az űrlapot, és kollégánk felveszi veled a kapcsolatot.
            </p>
          </div>
          
          <div className="bg-[#1a1a1a] rounded-2xl p-6 md:p-8 border border-white/10">
            <EpitkezesiLeadForm />
          </div>
          
          {/* Trust Message */}
          <div className="mt-8 text-center">
            <p className="text-gray-500 text-sm max-w-lg mx-auto">
              A HOPPhomes minden ügyfelet saját rendszerében kezel, és a projekt jellegéhez leginkább illeszkedő kivitelezőt választja ki.
            </p>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
